var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { create } from 'zustand';
export var useCacheStore = create(function (set, get) { return ({
    cache: {},
    setCache: function (key, data) {
        set(function (state) {
            var _a;
            return ({
                cache: __assign(__assign({}, state.cache), (_a = {}, _a[key] = data, _a)),
            });
        });
    },
    getCache: function (key) {
        var _a;
        var state = get();
        return (_a = state.cache[key]) !== null && _a !== void 0 ? _a : null;
    },
    removeCache: function (key) {
        set(function (state) {
            var _a = state.cache, _b = key, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return { cache: rest };
        });
    },
    clearAllCache: function () {
        set({ cache: {} });
    },
}); });
